import * as actionTypes from 'src/actions';
import { decodeToken } from 'src/utils/jwt';

export const userRoles = Object.freeze({
  GUEST: 'GUEST',
  ADMIN: 'ADMIN',
  SUPERADMIN: 'SUPERADMIN',
  PLAY_AS: 'PLAY_AS'
});

export const adminRoles = Object.freeze({
  BASIC: 'basic',
  FULL: 'full'
});

export const superAdminRoles = Object.freeze({
  BASIC: 'basic',
  IT: 'it'
});

const initialState = {
  loggedIn: false,
  userType: null,
  user: {
    email: '',
    token: '',
    superToken: '',
    twoFactorAuthStatus: '',
    twoFactorAuthEnabled: false,
    enforced2FA: false,
    role: userRoles.GUEST,
    adminRole: adminRoles.BASIC,
    superAdminRoles: []
  },
  persistor: {
    admin: {
      token: '',
      companyId: '',
      email: ''
    },
    superAdmin: {
      token: '',
      email: ''
    },
    playAs: {
      token: '',
      companyId: ''
    }
  }
};

const setLocalStorage = state =>
  localStorage.setItem('state', JSON.stringify(state));

const sessionReducer = (state = initialState, action) => {
  const decodedToken = decodeToken(action.token);
  const adminRole = decodedToken?.data?.role ?? adminRoles.BASIC;
  const superAdminActions = decodedToken?.data?.allowedActions ?? [];
  const isSuperAdmin = decodedToken?.data?.superAdminId != null ?? false;
  const twoFactorAuthEnabled = decodedToken?.data?.twoFactorAuthEnabled;
  const enforced2FA = decodedToken?.data?.enforced2FA;

  switch (action.type) {
    // TODO: to be deprecate
    case actionTypes.SESSION_LOGIN: {
      const newState = {
        ...state,
        loggedIn: true,
        user: {
          ...state.user,
          email: action.email,
          token: action.token,
          twoFactorAuthEnabled,
          enforced2FA,
          superToken: undefined,
          role: action.role,
          adminRole,
          isSuperAdmin,
          superAdminActions
        }
      };

      setLocalStorage(newState);
      return {
        ...newState
      };
    }

    case actionTypes.SESSION_LOGIN_AS: {
      const newState = {
        ...state,
        userType: userRoles.PLAY_AS,
        user: {
          ...state.user,
          superToken: state.user.token,
          token: action.token,
          role: userRoles.ADMIN,
          adminRole
        },
        persistor: {
          ...state.persistor,
          playAs: {
            token: action.token,
            companyId: action.companyId
          }
        }
      };

      setLocalStorage(newState);
      return {
        ...newState
      };
    }

    case actionTypes.SESSION_LOGIN_ADMIN: {
      const newState = {
        ...state,
        loggedIn: true,
        userType: userRoles.ADMIN,
        user: {
          ...state.user,
          email: action.email,
          token: action.token,
          twoFactorAuthEnabled,
          enforced2FA,
          superToken: undefined,
          role: action.role,
          adminRole,
          isSuperAdmin,
          superAdminActions
        },
        persistor: {
          ...state.persistor,
          admin: {
            token: action.token,
            email: action.email
          }
        }
      };

      setLocalStorage(newState);
      return {
        ...newState
      };
    }

    case actionTypes.SESSION_LOGIN_SUPER: {
      const newState = {
        ...state,
        loggedIn: true,
        userType: userRoles.SUPERADMIN,
        user: {
          ...state.user,
          email: action.email,
          token: action.token,
          twoFactorAuthEnabled,
          enforced2FA,
          superToken: undefined,
          role: action.role,
          adminRole,
          isSuperAdmin,
          superAdminActions
        },
        persistor: {
          ...state.persistor,
          superAdmin: {
            token: action.token,
            email: action.email
          }
        }
      };

      setLocalStorage(newState);
      return {
        ...newState
      };
    }
    case actionTypes.SET_USER_STATE: {
      const newState = {
        ...state,
        user: {
          ...state.user,
          ...action.values
        }
      };

      setLocalStorage(newState);
      return {
        ...newState
      };
    }

    case actionTypes.SET_ME: {
      const newState = {
        ...state,
        user: {
          ...state.user,
          ...action.values
        }
      };

      setLocalStorage(newState);
      return {
        ...newState
      };
    }

    case actionTypes.SESSION_LOGOUT: {
      const newState = {
        ...initialState
      };

      setLocalStorage(newState);
      return {
        ...newState
      };
    }

    case actionTypes.SESSION_LOGOUT_AS: {
      const newState = {
        ...state,
        userType: userRoles.SUPERADMIN,
        user: {
          ...state.user,
          token: state.user.superToken,
          superToken: undefined,
          role: userRoles.SUPERADMIN,
          adminRole: ''
        },
        persistor: {
          ...state.persistor,
          playAs: {
            token: '',
            companyId: ''
          }
        }
      };
      setLocalStorage(newState);

      return {
        ...newState
      };
    }

    default: {
      return state;
    }
  }
};

export default sessionReducer;
